import { GetterTree } from "vuex";
import { IDemoState as DemoState } from "@/store/modules/demo/types";
import { RootState } from "@/store/types";
import { IContentSection } from "@/store/modules/content/types";

type DemoGetterTree = GetterTree<DemoState, RootState>;

export const getters: DemoGetterTree = {
  nextSection(state: DemoState): string {
    const nextSection = Object.entries(state.completedSections)
      .filter(s => !Object.values(s[1] as IContentSection).length)
      .map(s => s[0])
      .shift();

    return nextSection || "";
  },

  isSectionsFinished(state: DemoState): boolean {
    return Object.entries(state.completedSections).every(
      obj => obj[1] && Object.values(obj[1] as IContentSection).length
    );
  },

  completedSections(state: DemoState): {} {
    return state.completedSections;
  },

  isOngoingSection(state: DemoState): boolean {
    return Object.entries(state.completedSections).some(
      obj => obj[1] && Object.values(obj[1] as IContentSection).length
    );
  },

  getSection(state: DemoState): any {
    const { section } = state;
    if (section) {
      return section;
    }
  },

  getSections(state: DemoState): any {
    const { sections } = state;
    if (sections) {
      return sections;
    }
  },
};
